__turbopack_context__.v({
  "container": "LiveEventPanelInfo-module-scss-module___rD3Sa__container",
  "content": "LiveEventPanelInfo-module-scss-module___rD3Sa__content",
  "ctaButtonWrapper": "LiveEventPanelInfo-module-scss-module___rD3Sa__ctaButtonWrapper",
  "date": "LiveEventPanelInfo-module-scss-module___rD3Sa__date",
  "detailsLoadingSkeleton": "LiveEventPanelInfo-module-scss-module___rD3Sa__detailsLoadingSkeleton",
  "feeInformation": "LiveEventPanelInfo-module-scss-module___rD3Sa__feeInformation",
  "headline": "LiveEventPanelInfo-module-scss-module___rD3Sa__headline",
  "hidden": "LiveEventPanelInfo-module-scss-module___rD3Sa__hidden",
  "infoIcon": "LiveEventPanelInfo-module-scss-module___rD3Sa__infoIcon",
  "visible": "LiveEventPanelInfo-module-scss-module___rD3Sa__visible",
});
